module.exports = __webpack_public_path__ + "img/pembelian-saya.2bc8cf44.svg";